import * as React from 'react';

import './EntityCard.less';

const EntityCard: React.FunctionComponent<{}> = ({ children }) => (
  <div className="entity-card">{children}</div>
);

export default EntityCard;



// WEBPACK FOOTER //
// ./src/components/EntityCard/EntityCard.tsx